import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    ChipField,
    ShowButton,
    ReferenceManyField,
    FunctionField,
} from 'react-admin';
import CityField from '../../components/CityField';
import { Chip, makeStyles } from '@material-ui/core';
import humanize from '../../util/humanize';

const useStyles = makeStyles({
    relatedChip: {
        backgroundColor: '#e3f2fd',
        borderColor: '#2196f3',
        marginLeft: 8,
    },
});

const RelatedRequestField = ({ record }) => {
    const classes = useStyles();

    if (record && record.isRelatedRequest) {
        return (
            <Chip
                size="small"
                label="Related"
                className={classes.relatedChip}
            />
        );
    }
    return null;
};

export const OrderRequestsList = props => (
    <ReferenceManyField
        reference="requests"
        target="orderId"
        filter={{ orderId: props.record.id }}
        {...props}
    >
        <Datagrid>
            <TextField source="serial" sortable={false} />
            <DateField locales="en-IN" source="date" />
            <TextField source="status" />
            {/*}ChipField source="type" />*/}
            <FunctionField
                label="Type"
                render={record => {
                    return (
                        <>
                            <Chip label={humanize(record.type)} />
                            <RelatedRequestField record={record} />
                        </>
                    );
                }}
            />
            <CityField />
            <ShowButton />
        </Datagrid>
    </ReferenceManyField>
);
